import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { OposicionesC1Navbar } from '@/components/oposiciones/OposicionesC1Navbar';
import { PlanRedirect } from '@/components/routing/PlanRedirect';
import { Sidebar } from '@/components/sidebar/Sidebar';
import { GlobalGenerationManager } from '@/components/oposiciones/GlobalGenerationManager';
import { GenerationReadyNotifier } from '@/components/notifications/GenerationReadyNotifier';
import { prefetchArea } from '@/lib/routePrefetch';

export function OposicionesC1Layout() {
  const location = useLocation();
  const isChatRoute = location.pathname.startsWith('/app/oposiciones-c1/chat');

  useEffect(() => { prefetchArea('c1'); }, []);

  return (
    <div className="flex flex-col h-screen bg-background">
      <PlanRedirect />
      <GenerationReadyNotifier />
      <GlobalGenerationManager />
      <OposicionesC1Navbar />
      <div className="flex-1 flex overflow-hidden">
        {isChatRoute && (
          <div className="oposiciones-sidebar">
            <Sidebar variant="oposiciones" />
          </div>
        )}
        <main className="flex-1 flex flex-col overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
